import React from 'react';
import { motion } from 'framer-motion';
import logo from '../../assets/Logo.png'; // Adjust path to your logo

const LuxuryLoading = ({ message = "Loading your luxury experience..." }) => {
    return (
        <div className="fixed inset-0 bg-gradient-to-b from-pearl to-nude/30 flex items-center justify-center z-50">
            <div className="text-center">
                {/* Logo Animation */}
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{
                        scale: [0.8, 1.1, 1],
                        opacity: 1
                    }}
                    transition={{
                        duration: 0.8,
                        ease: "easeInOut"
                    }}
                    className="relative mb-8"
                >
                    <div className="relative w-32 h-32 mx-auto">
                        {/* Outer glow */}
                        <motion.div
                            animate={{
                                rotate: 360,
                                scale: [1, 1.1, 1]
                            }}
                            transition={{
                                rotate: {
                                    duration: 20,
                                    repeat: Infinity,
                                    ease: "linear"
                                },
                                scale: {
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }
                            }}
                            className="absolute inset-0 rounded-full bg-gradient-to-r from-champagne/20 via-sage/10 to-champagne/20"
                        />

                        {/* Logo container */}
                        <div className="absolute inset-2 rounded-full overflow-hidden bg-white shadow-luxury">
                            <img
                                src={logo}
                                alt="KROMAIC Logo"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* Pulsing rings */}
                        <motion.div
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{
                                scale: [0.8, 1.5, 0.8],
                                opacity: [0.3, 0.1, 0.3]
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                            className="absolute inset-0 border-2 border-champagne/30 rounded-full"
                        />
                        <motion.div
                            initial={{ scale: 0.6, opacity: 0 }}
                            animate={{
                                scale: [0.6, 1.3, 0.6],
                                opacity: [0.2, 0.05, 0.2]
                            }}
                            transition={{
                                duration: 2.5,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: 0.3
                            }}
                            className="absolute inset-4 border border-sage/20 rounded-full"
                        />
                    </div>

                    {/* Floating particles */}
                    {[1, 2, 3, 4, 5].map((i) => (
                        <motion.div
                            key={i}
                            initial={{
                                x: 0,
                                y: 0,
                                opacity: 0,
                                scale: 0
                            }}
                            animate={{
                                x: [0, Math.random() * 100 - 50],
                                y: [0, Math.random() * 100 - 50],
                                opacity: [0, 0.7, 0],
                                scale: [0, 1, 0]
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                delay: i * 0.2,
                                ease: "easeInOut"
                            }}
                            className="absolute w-1 h-1 bg-champagne rounded-full"
                            style={{
                                left: '50%',
                                top: '50%',
                                marginLeft: '-0.5px',
                                marginTop: '-0.5px'
                            }}
                        />
                    ))}
                </motion.div>

                {/* Loading text */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="space-y-4"
                >
                    <div className="flex items-center justify-center gap-2">
                        {[1, 2, 3].map((i) => (
                            <motion.div
                                key={i}
                                animate={{
                                    y: [0, -10, 0]
                                }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    delay: i * 0.2,
                                    ease: "easeInOut"
                                }}
                                className="w-1 h-1 bg-champagne rounded-full"
                            />
                        ))}
                    </div>

                    <p className="text-charcoal/60 text-sm font-light tracking-wider">
                        {message}
                    </p>

                    {/* Progress bar */}
                    <div className="w-48 h-0.5 bg-nude/20 rounded-full overflow-hidden mx-auto">
                        <motion.div
                            initial={{ x: '-100%' }}
                            animate={{ x: '100%' }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                            className="h-full bg-gradient-to-r from-transparent via-champagne to-transparent"
                        />
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default LuxuryLoading;